import { render, staticRenderFns } from "./JxfGame.vue?vue&type=template&id=4c8b7c84&scoped=true&"
import script from "./JxfGame.vue?vue&type=script&lang=js&"
export * from "./JxfGame.vue?vue&type=script&lang=js&"
import style0 from "./JxfGame.vue?vue&type=style&index=0&id=4c8b7c84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b7c84",
  null
  
)

export default component.exports